var path = 'views/webOptimizedHelp.html';
var html = "<div class=\"panel web-optimized-help\"> <h1 translate>webOptimizedHelp.header</h1> <div translate-sanitize-strategy=\"'sanitize'\" translate>webOptimizedHelp.description</div> </div> ";
window.angular.module('app').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;